let config = {
    envName: 'local',
    internalFairUniversitiesJsonUrl:
        "https://azent-fairs.s3.ap-south-1.amazonaws.com/fairs/final_staffing_9th_may_2026.json",
    breakoutApiBaseUrl: "https://breakout-api.azent.com",
    breakoutApiToken: "rddNQKHUIE_X_nV6uKyiAEjPIP4Di33SCzhhcc209VY",
    occupancyPublicBaseUrl:
        "https://zoom-breakout-occupancy.s3.ap-south-1.amazonaws.com/occupancy",
};

export default config;
